export enum TipoVariavel {
  INTEIRO = 'Inteiro',
  ALFANUMERICO = 'Alfanumérico',
  TEXTO = 'Texto',
  DATA = 'Data'
}
